/*
 *
 * EloquaVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_ELOQUA } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const eloquaVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_ELOQUA.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_ELOQUA.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_ELOQUA.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default eloquaVerifyReducer;
